import React, { useState, useEffect, useRef } from "react"
import { Table, Button, Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const AddFundType = () => {
  const formRef = useRef(null)
  const user = localStorage.getItem("authUser")
  const userInfo = JSON.parse(user)

  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState([])
  const [brands, setBrands] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    values.added_by = userInfo.uid
    const response = await api.post("create-fundtype", values)
    if (response.data.success === true) {
      formRef.current.reset()
      setSubmitted(true)
    }
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Fund Type</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/fundtypes" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            ref={formRef}
            className="form-horizontal mt-4"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="fund_type_name"
                    label="Fund Type Name"
                    value=""
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Fund Type is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Adding...</span>
                    </>
                  ) : (
                    <span>Add Item </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddFundType
